import axios from "axios";

const CACHE_KEY = "analyticsCache";
const LAST_FETCH_KEY = "analyticsLastFetch";

export const fetchAnalyticsData = async () => {
  const lastFetch = localStorage.getItem(LAST_FETCH_KEY);
  const diffMinutes = lastFetch ? (Date.now() - Number(lastFetch)) / 1000 / 60 : Infinity;

  if (diffMinutes < 20) {
    // Carica dati dalla cache
    const cachedData = JSON.parse(localStorage.getItem(CACHE_KEY) || "{}");
    return cachedData;
  }

  try {
    const response = await axios.get(
      "https://dashboard.technoparts.it/ws/index.php?Command=google.getAnalitycs"
    );
    const data = response.data || {};
    // Salva in cache
    localStorage.setItem(CACHE_KEY, JSON.stringify(data));
    localStorage.setItem(LAST_FETCH_KEY, Date.now().toString());
    return data;
  } catch (err) {
    console.error("Errore fetchAnalyticsData:", err);
    return JSON.parse(localStorage.getItem(CACHE_KEY) || "{}"); // fallback cache
  }
};
